import React, { useState } from "react";
import "./stylesAddGamePopup.css";
import { Check, X } from "react-feather";
import { PlusOutlined } from "@ant-design/icons";
import CustomAutoComplete from "../../../../../CommonComponents/CustomAutoComplete/CustomAutoComplete";

function AddGamePopup({
  isVisible,
  onClosePressed,
  allGames,
  ename,
  addGameInCasinoEntity,
  categories,
  etype,
}) {
  const [games, setGames] = useState(allGames.slice(0, 25));

  const allOptions = allGames.map((game) => ({
    label: game.name,
    value: game.name,
    game_id: game.game_id,
  }));

  const handleSubmit = async (e, game) => {
    e.preventDefault();
    try {
      await addGameInCasinoEntity({ ...game, ename, etype });
    } catch (error) {
      console.log(error);
    }
  };

  const handleClosePressed = () => {
    onClosePressed();
  };

  const handleChange = (value) => {
    const selectedGame = allGames.find((game) => game.game_id === value);
    setGames([selectedGame]);
  };

  const isGameInCategory = (gameId) => {
    const category = categories.find((category) => category.ename === ename);
    return category?.games.some((game) => game.game_id === gameId);
  };

  if (!isVisible) return null;

  return (
    <div className="add-game-popup">
      <div className="add-game-panel">
        <div className="add-game-panel-header">
          <h2>Add Game - {ename}</h2>
          <button className="close-button" onClick={handleClosePressed}>
            <X className="close-icon" />
          </button>
        </div>
        <form>
          <CustomAutoComplete
            allOptions={allOptions}
            handleChange={handleChange}
            clearOptions={() => setGames(allGames.slice(0, 25))}
          />
          <div className="add-game-available-games">
            {games.map((game, index) => (
              <div className="add-game-available-game" key={index}>
                <div className="left-content">
                  <img src={game.image} alt={game.name} />
                  <div>
                    <h4>{game.name}</h4>
                    <p>{game.category}</p>
                  </div>
                </div>
                {isGameInCategory(game.game_id) ? (
                  <button className="added-button" disabled>
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 5 }}
                    >
                      <Check style={{ width: "18px" }} /> Added
                    </div>
                  </button>
                ) : (
                  <button onClick={(e) => handleSubmit(e, game)}>
                    <PlusOutlined /> <span> Add</span>
                  </button>
                )}
              </div>
            ))}
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddGamePopup;
